//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'EndStageLiverDisease',
  data() {
    return {
      defaultJson:{
        'Dialysis frequency': "过去一周患者透析至少两次",
        "Serum Creatinine": "血清肌酐",
        "Serum bilirubin": "血清胆红素",
        "INR": "国际标准化比值",
        "Blood sodium": "血钠",
      },
      form:{
        df: '0',
        sc:'', //血清肌酐
        sb:'', //血清胆红素
        inr:'', //国际标准化比值
        bs:'', //血钠
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(88, form)
        // 第一步：
        // MELD(i)评分 = 10*[0.957*Loge(血清肌酐值)+0.378*Loge(血清胆红素值)+1.12*Loge(国际标准化比值)+ 0.643]
        // 第二步：
        // 若所得MELD(i)评分 >11，执行附加MELD评分计算，如下所示:
        // MELD评分 = MELD(i)评分+1.32* (137-血钠)- [ 0.033* MELD(i)评分* (137-血钠)]
        let sc = (form.df ? 4 : (form.sc < 1 ? 1 : (form.sc > 4 ? 4 : form.sc) ))
        let sb = form.sb < 1 ? 1 : form.sb
        let inr = form.inr < 1 ? 1 : form.inr
        let bs = form.bs < 125 ? 125 : (form.bs > 137 ? 137 : form.bs)
        let result = Math.round ((9.57 * Math.log(sc)) + (3.78 * Math.log(sb)) + (11.2 * Math.log(inr)) + 6.43)
        // console.log(99, result)
        if (result > 11) {
          result = result + 1.32 * (137 - bs) - [ 0.033 * result * (137 - bs)]
        }
        result = result > 40 ? 40 : result
        console.log('结果：', result)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/EndStageLiverDisease.vue